module.exports = __webpack_public_path__ + "static/media/cost-center-import.b8bb468a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cost-center-import.csv
// module id = ./src/assets/cost-center-import.csv
// module chunks = 11